import { ref } from 'vue'
import flagsmith from 'flagsmith'

type FlagsmithOnChange = (oldFlags: any, params: any) => void

const isInitialized = ref(false)
const isInitializing = ref(false)
const changeListeners: FlagsmithOnChange[] = []

export function useFeatureFlag() {
  const init = async (options?: { environmentID?: string; onChange?: FlagsmithOnChange }) => {
    if (isInitialized.value || isInitializing.value) {
      if (options?.onChange) changeListeners.push(options.onChange)
      return
    }
    isInitializing.value = true
    if (options?.onChange) changeListeners.push(options.onChange)

    const DEFAULT_FLAGSMITH_ENV_ID = 'm2YUuJY5MtRJdMKyiE5yet'
    const environmentID = DEFAULT_FLAGSMITH_ENV_ID

    try {
      await flagsmith.init({
        environmentID,
        onChange: (oldFlags: any, params: any) => {
          for (const cb of changeListeners) {
            try { cb(oldFlags, params) } catch { /* ignore */ }
          }
        },
      } as any)
      isInitialized.value = true
    } catch (e) {
      console.error('Flagsmith init failed:', e)
    } finally {
      isInitializing.value = false
    }
  }

  const getFlag = (key: string) => {
    try {
      return (flagsmith as any).getFlag?.(key)
    } catch {
      return undefined
    }
  }

  const hasFeature = (key: string): boolean => {
    try { return !!flagsmith.hasFeature(key) } catch { return false }
  }

  const getValue = (key: string): unknown => {
    try { return flagsmith.getValue(key) } catch { return undefined }
  }

  const onChange = (cb: FlagsmithOnChange) => {
    changeListeners.push(cb)
  }

  return { init, isInitialized, getFlag, hasFeature, getValue, onChange }
}
